import { getElement, getNamedEffect, measure, mutate } from './common';
import fastdom from 'fastdom';
function prepareAnimation(target, animation, callback) {
  const preset = getNamedEffect(animation);
  const element = target instanceof HTMLElement ? target : getElement(target);
  if (preset && preset.prepare && element) {
    const domApi = {
      measure: measure(element),
      mutate: mutate(element)
    };
    preset.prepare(animation, domApi);
  }
  callback && fastdom.mutate(callback);
}
export { prepareAnimation };
//# sourceMappingURL=prepare.js.map